"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Wizard = require("../Wizard/Wizard.js");
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
var _ProgressBarStepList = _interopRequireDefault(require("../Wizard/ProgressBarStepList.js"));
var _axios = _interopRequireDefault(require("axios"));
var _CalculatorTemplate = require("../Wizard/CalculatorTemplate.js");
var _utils = require("../../middleware/utils.js");
var _PageOneSideContent = _interopRequireDefault(require("./ForcedSideContent/PageOneSideContent.js"));
var _PageThreeSideContent = _interopRequireDefault(require("./ForcedSideContent/PageThreeSideContent.js"));
var _GLWBPageOne = _interopRequireDefault(require("./GLWBPageOne.js"));
var _GLWBPageTwo = _interopRequireDefault(require("./GLWBPageTwo.js"));
var _GLWBPageThree = _interopRequireDefault(require("./GLWBPageThree.js"));
var _GLWBPageFour = _interopRequireDefault(require("./GLWBPageFour.js"));
var _GeneratePayload = _interopRequireDefault(require("./GeneratePayload.js"));
var _lodash = require("lodash");
var _utils2 = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-tabs */
var GuaranteedLifetimeWithdrawalBenefitWizardCalc = props => {
  var {
    config
  } = props;
  var [stepNumber, setStepNumber] = (0, _react.useState)(0);
  var [isEditable, setIsEditable] = (0, _react.useState)(false);
  var [apiData, setApiData] = (0, _react.useState)({});
  var [errorData, setErrorData] = (0, _react.useState)(null);
  var [validationData, setValidationData] = (0, _react.useState)(null);
  var currentConfig = config.Steps[stepNumber];
  var progressSteps = ['Client information', 'Product information', 'Select growth rate', 'Income amounts'];
  var handlePDFTealium = () => {
    (0, _utils2.customTealiumEvent)(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName, 'click', 'downloadAsPDF');
  };
  var handlePDFDownload = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (data) {
      handlePDFTealium();
      var singleJoint = data.isSingleLife == 'singleLife' ? 'Single Life' : 'Joint Life';
      var stateResidence = data.isNewYork == 'newYork' ? 'New York' : 'Other State';
      var todayDate = new Date().toLocaleDateString('en-US');
      var bodyContent = {
        calcType: 'glwb',
        todayDate: todayDate,
        net_market_growth_rate: data.net_market_growth_rate,
        singleJoint: singleJoint,
        issueAge: data.issueAge,
        purchasePayment: '$' + data.purchasePayment,
        stateResidence: stateResidence,
        rollUpRate: data.rollUpRate,
        rollUpPeriod: data.rollUpPeriod,
        interestType: data.interestRollUp,
        calcData: apiData
      };
      var headers = {
        responseType: 'arraybuffer'
      };
      try {
        var apiUrl = (0, _lodash.get)(config, 'CONTENT_API_CALC_PDF', '/apicalls/downloadpdf/calcpdf');
        yield _axios.default.post(apiUrl, bodyContent, headers).then(response => {
          var file = new Blob([response.data], {
            type: 'application/pdf'
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        });
      } catch (error) {
        console.log('GuaranteedLifetimeWithdrawalBenefitWizardCalc handlePDFDownload error: ', error);
      }
    });
    return function handlePDFDownload(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  function convertToDollars(fieldName, fieldValue) {
    return fieldValue.map(fieldValue => fieldValue !== 'N/A' ? (0, _utils.numberToCurrencyString)(fieldValue) : 'N/A');
  }
  function convertToPercent(fieldName, fieldValue) {
    return fieldValue.map(fieldValue => fieldValue !== 'N/A' ? "".concat(parseFloat(fieldValue).toFixed(2), "%") : 'N/A');
  }
  var fetchDataScienceResults = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (values) {
      // Reset error data to get rid of any Alerts
      setErrorData(null);
      try {
        var payload = (0, _GeneratePayload.default)(values, apiData);
        var result = yield _axios.default.post(config.API_URL, payload);

        // benefit_base_MM_growth_x
        result.data.benefit_base_MM_growth_x = convertToDollars('benefit_base_MM_growth_x', result.data.benefit_base_MM_growth_x);

        // withdrawal_rate_competitor_growth_x
        result.data.withdrawal_rate_MM_growth_x = convertToPercent('withdrawal_rate_MM_growth_x', result.data.withdrawal_rate_MM_growth_x);

        // annual_lifetime_benefit_amount_MM_growth_x
        result.data.annual_lifetime_benefit_amount_MM_growth_x = convertToDollars('annual_lifetime_benefit_amount_MM_growth_x', result.data.annual_lifetime_benefit_amount_MM_growth_x);

        // benefit_base_competitor_growth_x
        result.data.benefit_base_competitor_growth_x = convertToDollars('benefit_base_competitor_growth_x', result.data.benefit_base_competitor_growth_x);

        // withdrawal_rate_competitor_growth_x
        result.data.withdrawal_rate_competitor_growth_x = convertToPercent('withdrawal_rate_competitor_growth_x', result.data.withdrawal_rate_competitor_growth_x);

        // annual_lifetime_benefit_amount_competitor_growth_x
        result.data.annual_lifetime_benefit_amount_competitor_growth_x = convertToDollars('annual_lifetime_benefit_amount_competitor_growth_x', result.data.annual_lifetime_benefit_amount_competitor_growth_x);

        // benefit_base_MM_growth_0
        result.data.benefit_base_MM_growth_0 = convertToDollars('benefit_base_MM_growth_0', result.data.benefit_base_MM_growth_0);

        // withdrawal_rate_MM_growth_0
        result.data.withdrawal_rate_MM_growth_0 = convertToPercent('withdrawal_rate_MM_growth_0', result.data.withdrawal_rate_MM_growth_0);

        // annual_lifetime_benefit_amount_MM_growth_0
        result.data.annual_lifetime_benefit_amount_MM_growth_0 = convertToDollars('annual_lifetime_benefit_amount_MM_growth_0', result.data.annual_lifetime_benefit_amount_MM_growth_0);

        // benefit_base_competitor_growth_0
        result.data.benefit_base_competitor_growth_0 = convertToDollars('benefit_base_competitor_growth_0', result.data.benefit_base_competitor_growth_0);

        // withdrawal_rate_competitor_growth_0
        result.data.withdrawal_rate_competitor_growth_0 = convertToPercent('withdrawal_rate_competitor_growth_0', result.data.withdrawal_rate_competitor_growth_0);

        // annual_lifetime_benefit_amount_competitor_growth_0
        result.data.annual_lifetime_benefit_amount_competitor_growth_0 = convertToDollars('annual_lifetime_benefit_amount_competitor_growth_0', result.data.annual_lifetime_benefit_amount_competitor_growth_0);
        setApiData(result);
      } catch (err) {
        /* istanbul ignore next*/
        console.error(err);
        setErrorData(err.message);
        throw Error('Unexpected error');
      }
    });
    return function fetchDataScienceResults(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement("div", {
    id: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName
  }, /*#__PURE__*/_react.default.createElement(_ProgressBarStepList.default, {
    subtitle: progressSteps[stepNumber],
    activeStep: stepNumber + 1,
    steps: 4
  }), /*#__PURE__*/_react.default.createElement(_CalculatorTemplate.CalculatorTemplate, {
    config: config,
    currentConfig: currentConfig,
    stepNumber: stepNumber,
    customSideContent: [/*#__PURE__*/_react.default.createElement(_PageOneSideContent.default, {
      key: 1
    }), null, /*#__PURE__*/_react.default.createElement(_PageThreeSideContent.default, {
      key: 3
    })]
  }, /*#__PURE__*/_react.default.createElement(_Wizard.Wizard, {
    passthroughId: "GuaranteedLifetimeWithdrawalBenefitWizardCalc",
    setStepNumber: setStepNumber,
    stepNumber: stepNumber,
    initialValues: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.initialValuesConfig,
    initialTouched: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.initialTouchedConfig,
    onSubmit: null,
    currentConfig: currentConfig,
    validationData: validationData,
    setValidationData: setValidationData,
    errorData: errorData,
    calcName: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName,
    maxSteps: 4,
    isNotNatLang: [true, true, true, false],
    disabledSubmit: isEditable,
    disabledBack: isEditable,
    centerNavButtons: [false, false, false, false]
  }, /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.validationConfig[0]
  }, /*#__PURE__*/_react.default.createElement(_GLWBPageOne.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.validationConfig[1]
  }, /*#__PURE__*/_react.default.createElement(_GLWBPageTwo.default, {
    setIsEditable: setIsEditable,
    isEditable: isEditable
  })), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: fetchDataScienceResults,
    validationSchema: _GuaranteedLifetimeWithdrawalBenefitWizardCalc.validationConfig[2]
  }, /*#__PURE__*/_react.default.createElement(_GLWBPageThree.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: handlePDFDownload,
    validationSchema: null,
    nextButtonAsTypeButton: true,
    hideNext: config.Steps[stepNumber].NextButton.HideNext,
    apiData: apiData
  }, /*#__PURE__*/_react.default.createElement(_GLWBPageFour.default, {
    fetchDataScienceResults: fetchDataScienceResults,
    apiData: apiData
  })))));
};
var _default = exports.default = GuaranteedLifetimeWithdrawalBenefitWizardCalc;